/* tslint:disable */
/* eslint-disable */
/**
 * ProjectOne API
 * API for Classical Conversations content and communities.  # Service URLs In local dev: - [The **local backend**](http://0.0.0.0:8080/) defaults to running on port 8080. - [The **local frontend**](http://0.0.0.0:3000/) defaults to running on port 3000.  In the DEV environment: - [The **DEV backend**](https://dev-ccp1-api.classicaltesting.net/) runs at https://dev-ccp1-api.classicaltesting.net/. - [The **DEV frontend**](https://dev-ccp1.classicaltesting.net/) runs at https://dev-ccp1.classicaltesting.net/.  The TEST environment is similar, but with `test-` instead of `dev-`.
 *
 * The version of the OpenAPI document: c552c281 (Wed Jul  1 16:38:58 UTC 2026)
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * When creating a new program it can be in draft status prior to be published.
 * @export
 * @enum {string}
 */
export enum ProgramStatus {
  Draft = 'Draft',
  Published = 'Published',
  Complete = 'Complete',
  Archived = 'Archived',
}

export function ProgramStatusFromJSON(json: any): ProgramStatus {
  return ProgramStatusFromJSONTyped(json, false)
}

export function ProgramStatusFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): ProgramStatus {
  return json as ProgramStatus
}

export function ProgramStatusToJSON(value?: ProgramStatus | null): any {
  return value as any
}
